import * as THREE from "three";
import {ImageItem} from "./image-item";
import threeSketch from "../../../libs/three-sketch";
import EmitEvent, {HT_RESIZE, SMOOTH_SCROLLING} from "../../../libs/emit-event";
import {MathLerp, MathMap} from "../../../libs/math-utils";
import services from "../../../libs/services";

export class WebglImages {
    constructor() {

        this.uniforms = {
            u_strength: {value: 22.5}
        }
        this.webglImages = [];

        this.strength = {
            current: 0,
            ease: .1
        }

        this.handleScrolling = this.handleScrolling.bind(this);
        this.loop = this.loop.bind(this);

        this.init();
        this.bindEvent();
    }

    init() {

        const DomItems = document.querySelectorAll('.js-webgl-image');
        if (DomItems.length > 0) {
            const images = [];
            this.groupList = new THREE.Group();
            threeSketch.addGroup(this.groupList);

            DomItems.forEach(webgl_image => {
                const imageItem = new ImageItem({
                    el: webgl_image, addGroup: this.addMesh.bind(this),
                    uniforms: this.uniforms
                });
                this.webglImages.push(imageItem);
            });

            threeSketch.addLoop(this.loop);
        }
    }

    addMesh(mesh) {
        this.groupList.add(mesh);
    }

    handleScrolling({instance}) {
        if (this.webglImages.length) {
            this.webglImages.forEach(item => {
                item.handleScrolling(instance);
            });

            threeSketch.render();
        }
    }

    loop() {
        this.strength.current = MathLerp(this.strength.current, Math.abs(services.smooth_scrolling_instance), this.strength.ease)
        this.uniforms.u_strength.value = MathMap(Math.abs(Math.abs(services.smooth_scrolling_instance) - this.strength.current), 0, 100, 0, 50);
    }

    bindEvent() {
        EmitEvent.on(SMOOTH_SCROLLING, this.handleScrolling);
    }

    removeEvent() {
        threeSketch.removeLoop(this.loop);
        threeSketch.removeGroup(this.groupList);
        this.webglImages.forEach(item => {
            item.removeEvent();
        });
        EmitEvent.off(SMOOTH_SCROLLING, this.handleScrolling);
    }
}